import { createSelector } from 'reselect';
import getMonthsFromNowNumber from '../modules/getMonthsFromNowNumber';
import precise from '../modules/precise';
import getMonthLabelFromNumber from '../modules/getMonthLabelFromNumber';

const SVCFeesTotalSelector = state => state.registration.SVCFEE_TOTAL;
const BaseFeeSelector = state => state.registration.BaseFee;
const MonthsSelector = state => state.registration.monthsFromNow;
const selectedMonthNumberSel = state => state.registration.selectedMonthNumber;

const totalBaseAndSVCFeeString = createSelector(
  [SVCFeesTotalSelector, BaseFeeSelector, MonthsSelector, selectedMonthNumberSel],
  (svc, base, months, selectedMonthNumber) => {
    let s = '';
    if (months) {
      const n = getMonthsFromNowNumber(months);
      const label = getMonthLabelFromNumber(selectedMonthNumber);

      s += `<b>${n} month${n > 1 ? 's' : ''} (${label})</b> `;
    }
    if (base) {
      s += `<span class="Row-subtext">${precise(base)} (Base)</span>`;
    }
    if (svc && Number(svc) > 0) {
      s += ` <span class="Row-subtext">+ ${svc} (SVC)</span>`;
    }
    return s;
  },
);

export default totalBaseAndSVCFeeString;
